import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { Loader } from 'is24-corecss'
import { Styles } from '../../../../@types/types'

const styles: Styles = {
  maxWidth: {
    maxWidth: 120,
  },
  bgColor: {
    backgroundColor: 'var(--color-background-default)',
  },
}

export interface PublicationBarLoaderProps {}

const PublicationBarLoader: React.FC<PublicationBarLoaderProps> = () => {
  const { t } = useTranslation()
  return (
    <div className='grid grid-flex gutter-horizontal-m grid-justify-center padding-m' style={styles.bgColor}>
      <div className='grid-item grid-align-center' role='status'>
        <Loader size='small' />
      </div>
      <div className='grid-item font-body-small-regular font-line-s' style={styles.maxWidth}>
        {t('stickyPublicationBar.loader', 'The inputs are being saved ...')}
      </div>
    </div>
  )
}
export default PublicationBarLoader
